import { useState, useEffect } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Footer from '../common/Footer';
import styles from './PublicLayout.module.css';

const PublicLayout = () => {
  const { user } = useAuth();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let cachedThreshold = null;
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        if (cachedThreshold === null) {
          const heroSection = document.querySelector('[class*="hero"]');
          cachedThreshold = heroSection ? heroSection.offsetHeight - 60 : window.innerHeight * 0.8;
        }
        setScrolled(window.scrollY > cachedThreshold);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.layout}>
      {/* Floating Navbar */}
      <nav className={`${styles.navbar} ${scrolled ? styles.navbarScrolled : ''}`}>
        <Link to="/" className={styles.logo}>
          <img loading="eager" src="/oval-logo.webp" alt="OVAL" className={styles.logoImg} />
        </Link>
        <div className={styles.navActions}>
          {user ? (
            <Link to="/dashboard" className={styles.signUpBtn}>Dashboard</Link>
          ) : (
            <>
              <Link to="/login" className={styles.signInBtn}>Member Login</Link>
              <Link to="/register" className={styles.signUpBtn}>Inquire</Link>
            </>
          )}
        </div>
      </nav>

      {/* Main Content */}
      <main className={styles.main}>
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PublicLayout;
